import _ from "lodash";
import SimpleAudioAPI from "@/js/libs/SimpleAudioAPI";
import PolyfillAudioAPI from "@/js/libs/PolyfillAudioAPI";
import { AUDIO_SRC } from "@/const/config";

const UA = window.navigator.userAgent.toLowerCase();
const IS_IE = UA.indexOf("msie") >= 0 || UA.indexOf("trident") >= 0;

let firstTap = false;

export const audioApi = IS_IE ? new PolyfillAudioAPI() : new SimpleAudioAPI();

export function preloadAudio() {
  _.each(AUDIO_SRC, url => {
    audioApi.loadSound(url);
  });
}

export function pingAudio() {
  if (firstTap) return;
  firstTap = true;
  preloadAudio();
  return audioApi.ping();
}
